import React, { useState } from 'react';
import './common.css';
import logoDefault from '../../assets/images/logo.png';
import { FaBell } from 'react-icons/fa';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

// import logo '';
<style>

</style>

// Import all possible logos
// Example: import logoAirporttaxima from '../../assets/images/logo_airporttaxima.png';
// Add more imports as you add more logo files for each domain

// Example logo links for each domain
const domainLogoMap = {
  'airporttaxima.com': 'logoDefault',
  'gobostonloganairport.com': 'https://gobostonloganairport.com/assets/images/logo.png',
  'bostonairportexpresscar.com': 'https://bostonairportexpresscar.com/static/media/logo.88f461a2665014ffe1bc.png',
  'bostonairportcheapcar.com': 'https://bostonairportcheapcar.com/assets/images/logo.png',
  'loganairportcar.com': 'https://loganairportcar.com/assets/images/logo.png',
  'bostonloganairportcab.com': 'https://bostonloganairportcab.com/assets/images/logo.png',
  'natickairporttaxi.com': 'https://natickairporttaxi.com/static/media/image1.7ed04203391456d2095e.png',
  'concordairporttaxi.com': 'https://concordairporttaxi.com/static/media/logo.d0dc22d4b1a265454993.png',
  'airportcarlexington.com': 'logoDefault',
  'walthamairporttaxi.com': 'https://walthamairporttaxi.com/assets/image/footer-logo.png',
  'airporttaxiarlington.com': 'https://airporttaxiarlington.com/assets/images/biz-logo.png',
  'airporttaxicambridgema.com': 'https://airporttaxicambridgema.com/assets/images/logo.png',
  'airporttaxiandover.com': 'logoDefault',
  'newtonairporttaxima.com': 'https://newtonairporttaxima.com/assets/images/logo.png',
  'actonairporttaxi.com': 'https://actonairporttaxi.com/assets/images/nav_logo.png',
  'hudsonairporttaxi.com': 'logoDefault',
  'bosairportlimos.com': 'https://bosairportlimos.com/assets/images/biz-logo.png',
  'westonairporttaxima.com': 'https://westonairporttaxima.com/assets/images/hdr-logo.png',
  'wilmingtonairporttaxis.com': 'https://wilmingtonairporttaxis.com/assets/images/logo.png',
  'bostonairportcarma.com': 'https://bostonairportcarma.com/assets/images/logo.png',
  'bostonairporttaxis.com': 'https://bostonairporttaxis.com/assets/image/logo.png',
  'gologanairport.com': 'https://dispatch.gologanairport.com/assets/images/logo-sm.png',
  'gobostonairport.com': 'https://gobostonairport.com/assets/images/logo.png',
  'worcesterairporttaxi.com': 'https://worcesterairporttaxi.com/images/Logo%20Blue.png',
  'loganexpresscar.com': 'https://loganexpresscar.com/assets/images/logo.svg',
  'localhost': logoDefault,
};

function getCurrentDomain() {
  const host = window.location.hostname;
  const parts = host.split('.');
  if (parts.length >= 3) {
    return parts.slice(1).join('.');
  }
  return host;
}

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const toggleMenu = () => {
        setIsOpen((prev) => !prev); // Toggles the state correctly
    };
    // Determine logo based on domain
    const currentDomain = getCurrentDomain();
    const logoSrc = domainLogoMap[currentDomain] || logoDefault;
    return (
        <div className="nav-main">
            {/* <nav className="navbar">
                <div className="logo">
                    <img src={ logo } alt='Logo' />
                </div>
                <ul className="nav">
                    <li><a href="/">Dashboard</a></li>
                    <li><a href="/">Request Ride</a></li>
                    <li><a href="/">Scheduled</a></li>
                    <li><a href="/">History</a></li>
                    <li><a href="/">FAQ</a></li>
                    <li><a href="/">Support</a></li>
                    <li><a href="/">Account</a></li>
                </ul>
                <div className='notification'>
                    <FaBell size={ 20 } color="white" />
                </div>
            </nav> */}
            <nav className="navbar">
                <div className="nav-container">
                    <div className="logo-content d-flex align-items-center">
                        <a className="logo">
                            <img src={ logoSrc } alt='Logo' />
                        </a>
                        {/* Navigation links */ }
                        <ul className={ `nav ${isOpen ? "" : "show"}` }>
                            <li><a href="/">Dashboard</a></li>
                            <li><a href="/">Request Ride</a></li>
                            <li><a href="/">Scheduled</a></li>
                            <li><a href="/">History</a></li>
                            <li><a href="/">FAQ</a></li>
                            <li><a href="/">Support</a></li>
                            <li><a href="/">Account</a></li>
                        </ul>
                    </div>
                    <div className="main-container-notification d-flex align-items-center gap-2">
                        <div className='notification'>
                            <FaBell size={ 20 } color="white" />
                        </div>
                        {/* Toggle button */ }
                        <button className="toggle-btn" onClick={ toggleMenu }>
                            <FontAwesomeIcon icon={ isOpen ? faBars : faTimes } />
                        </button>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
